<section class="w-full h-[168px] md:h-[176px] overflow-y-hidden">
    <swiper-container #swiper appSwiper [config]="config" init="false" class="w-full h-[168px] md:h-[176px]">
        <swiper-slide *ngFor="let staticItem of staticBanners" class="h-full">
            <div
                class="h-full rounded-lg md:flex-between-center cursor-pointer"
                [ngStyle]="{
                    backgroundColor: staticItem.backgroundColor
                }"
                [ngClass]="{
                    'text-white': staticItem.theme === 'dark',
                    'text-black': staticItem.theme === 'light'
                }"
                (click)="goToLink(staticItem.link)"
            >
                <div class="p-4 md:p-6 min-w-[50%]">
                    <div class="text-base md:text-[28px] md:leading-10 font-semibold" [innerHTML]="staticItem.title | safeHtml"></div>
                    <div class="text-xs md:text-base md:mt-1 mb-3 md:mb-4 md:min-h-[24px]">{{staticItem.description}}</div>

                    <button *ngIf="staticItem.theme === 'light'" nz-button nzType="primary" class="w-[100px] md:w-[130px] !font-semibold">
                        <span class="colorful-text max-md:text-xs">Try Now</span>
                        <span nz-icon nzType="antd:v2-long-right-arrow-colorful" class="text-xl md:text-2xl"></span>
                    </button>

                    <button *ngIf="staticItem.theme === 'dark'" nz-button class="!bg-gradient !text-black !border-none w-[100px] md:w-[130px] !font-semibold">
                        <span class="max-md:text-xs">Try Now</span>
                        <span nz-icon nzType="antd:v2-long-right-arrow" class="text-xl md:text-2xl"></span>
                    </button>
                </div>

                <div class="max-md:hidden flex-1 flex-between-center pr-6 h-full">
                    <div></div>

                    <img [src]="staticItem.img" alt="" class="w-auto h-full object-contain rounded-lg" />

                    <div *ngIf="staticBanners.length > 1" class="flex-col flex-center-center gap-y-2 w-2">
                        <div
                            *ngFor="let item of staticBanners;let i = index"
                            (click)="swiper.swiper.slideTo(i)"
                            class="w-2 rounded-md cursor-pointer transition-all min-w-2 min-h-2"
                            [ngClass]="{
                                'bg-opacity-100 h-8': i === activeIndex,
                                'bg-opacity-30 h-2': i !== activeIndex,
                                'bg-white': staticItem.theme === 'dark',
                                'bg-black': staticItem.theme === 'light'

                            }"
                        ></div>
                    </div>
                </div>

                <div class="md:hidden w-full flex justify-between items-end absolute bottom-0 left-0 pointer-events-none rounded-md overflow-hidden">
                    <div *ngIf="staticBanners.length > 1" class="flex-1 flex-start-center gap-2 h-2 p-4">
                        <div
                            *ngFor="let item of staticBanners;let i = index"
                            (click)="swiper.swiper.slideTo(i)"
                            class="w-1.5 rounded-md cursor-pointer transition-all min-w-1.5 min-h-1.5"
                            [ngClass]="{
                                'bg-opacity-100 w-[22px]': i === activeIndex,
                                'bg-opacity-30 w-1.5': i !== activeIndex,
                                'bg-white': staticItem.theme === 'dark',
                                'bg-black': staticItem.theme === 'light'
                            }"
                        ></div>
                    </div>
                    <img [src]="staticItem.img" alt="" class="flex-1 h-[105px] object-contain" />
                </div>
            </div>
        </swiper-slide>
    </swiper-container>
</section>
